import { configureStore } from '@reduxjs/toolkit';
import { apiSlice } from './api/apiSlice';
import authReducer from '../features/auth/authSlice';
import messageReducer from '../features/message/messageSlice';
import dialogReducer from '../features/dialog/dialogSlice';
import notificationsReducer from '../features/notifications/notificationsSlice';
import tourReducer from '../features/tour/tourSlice';
import rolePreviewReducer from '../features/rolePreview/rolePreviewSlice';

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authReducer,
    message: messageReducer,
    dialog: dialogReducer,
    notifications: notificationsReducer,
    tour: tourReducer,
    rolePreview: rolePreviewReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(apiSlice.middleware),
  devTools: true,
});
